import { BaseModel } from "@blue-chip/core";

export default class ProjectSummary extends BaseModel {}
